
export const Locations = [
    null,
    "BATEMANS BAY",
    "SYDNEY",
    "CONTRACTOR"
]


